export default __webpack_public_path__ + "img/shape-circle-small.2c721495.svg";